'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    margin-top: 1rem;\n'], ['\n    display: flex;\n    flex-direction: row;\n    gap: 16px;\n    margin-top: 1rem;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _metrixCommon = require('metrix-common');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ValidationBannerContainer = _styledComponents2.default.div(_templateObject);

var ValidationBanner = function ValidationBanner(_ref) {
    var component = _ref.component;

    var text = component.elements && component.elements.find(function (element) {
        return element.code === 'Text';
    }) && component.elements.find(function (element) {
        return element.code === 'Text';
    }).value;
    var alignment = component.elements && component.elements.find(function (element) {
        return element.code === 'Alignment';
    }) && component.elements.find(function (element) {
        return element.code === 'Alignment';
    }).value;
    var visible = component.elements && component.elements.find(function (element) {
        return element.code === 'visible';
    }) && component.elements.find(function (element) {
        return element.code === 'visible';
    }).value;

    if (!visible) return null;

    return _react2.default.createElement(
        ValidationBannerContainer,
        { top: top },
        _react2.default.createElement(_metrixCommon.ErrorIcon, { mode: 'error',
            size: 24
        }),
        _react2.default.createElement(_metrixCommon.Label, { textAlign: _metrixCommon.Alignments[alignment],
            text: text,
            color: _metrixCommon.Colors.Error
        })
    );
};

exports.default = ValidationBanner;